export enum VisitorType {
    VISITOR = 'VISITOR', VISITORGROUP = 'VISITORGROUP'
}

export class TypeFilter {

    /** Uniquely identifies a quickfilter. */
    id: string;
    /** css style of image show for this filter. */
    icon: string;
    /** dictionary key used as tooltip. */
    title: string;
    /** if this filter is currently selected. */
    selected: boolean;

    visitorType: VisitorType;
}

export class VisitorUpfrontRegistationFilterModel {
    filterText = '';
    visitorTypes = new Array<VisitorType>();
}
